import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useNewNote } from '../components/NewNoteDialog';
import { useCampaignId } from '../hooks';
import { t } from '../i18n';
import { splitTarget } from '../util';

export function OpenLinksPage() {
  const cid = useCampaignId();
  const navigate = useNavigate();
  const newNote = useNewNote();
  const q = useQuery({ queryKey: ['openLinks', cid], queryFn: () => api.openLinks(cid) });

  return (
    <div className="page-narrow">
      <h1>{t('openLinks.title')}</h1>
      {q.data?.length === 0 && <p className="muted">{t('openLinks.none')}</p>}
      <ul className="open-links">
        {q.data?.map((l) => (
          <li key={l.rawTarget}>
            <span className="wikilink unresolved">{l.rawTarget}</span>
            <span className="muted small">
              {' '}
              {t('openLinks.from')}{' '}
              {l.sources.map((s, i) => (
                <span key={s.id}>
                  {i > 0 && ', '}
                  <Link to={`/c/${cid}/n/${s.id}`}>{s.title}</Link>
                </span>
              ))}
            </span>
            <button
              className="small-btn"
              onClick={() => {
                const { folder, title } = splitTarget(l.rawTarget);
                newNote.open({ title, folder, onCreated: (id) => navigate(`/c/${cid}/n/${id}?edit=1`) });
              }}
            >
              + {t('openLinks.create')}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
